// Module
var code = "<fieldset class=\"group-control property-group\" data-bind=\"preventBubble: ['click'], visible: !IsHiddenByAction\"> <legend class=\"group-control-label\" data-bind=\"text: Name\"></legend> <div> <!--ko foreach: PropertyControls--> <!--ko template: {html: $data.GetTemplate.bind($data)}--><!--/ko--> <!--/ko--> </div> </fieldset>";
// Exports
export default code;